import { asEnum } from "../lib";

export const MosadInvolvementLevels = asEnum({
  InvolvementLevels: 9502,
  FullTime: -457,
  PartTime: -458,
});
